import ReplaceBehavior from './ReplaceBehavior';

export default {
  __init__: [
    'elementTemplatesReplaceBehavior'
  ],
  elementTemplatesReplaceBehavior: [ 'type', ReplaceBehavior ]
};
